const ClearNotification = () => async (dispatch) => {
  console.log('Action Clear snack');
  dispatch({ type: 'SNACKBAR_CLEAR' });
};

export default ClearNotification;
